import React from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import SmallComponent from "./SmallComponent";
import BigComp from "./BigComp";


const ResponsiveSection = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm")); // true for xs screen
  const isMediumOrLarger = useMediaQuery(theme.breakpoints.up("sm")); // true for sm and above

  const bgImageDesktop = "/Images/BGG.png";
  const bgImageMobile = "/Images/SMABG.png";

  return (
    <Box
      // sx={{
      //   // backgroundImage: `url(${isSmallScreen ? bgImageMobile : bgImageDesktop})`,
      //   // backgroundSize: "contain",
      //   // backgroundPosition: "center",
      //   // backgroundRepeat: "no-repeat",
      //   minHeight: { xs: "100vh", sm: "70vh", md: "100vh" },
      //   display: "flex",
      //   alignItems: "center",
      //   justifyContent: "center",
      //   backgroundColor: "#04142a",
      //   px: 2,
      // }}
    >
      {isSmallScreen ? <SmallComponent /> : <BigComp />}
    </Box>
  );
};

export default ResponsiveSection;
